<template>
	<div class="lockUserDetail">
		<div class="title-con">
			<div class="left-con">
				<span class="title">用户列表</span>
			</div>
		</div>
		<el-table :data="lockData.list" stripe style="width: 100%" v-if="lockData">
			<el-table-column :label="iKey.label" :label-class-name="iKey.key" :width="iKey.width" v-for="iKey in lockDetailKey" :key="iKey.key" show-overflow-tooltip>
				<template slot-scope="scope">
					<span v-if="iKey.key!='partnerName'">{{ scope.row[iKey.key]}}</span>
					<span v-if="iKey.key=='partnerName' && promotorType==1" >
						<!-- 城市合伙人  获取用户渠道-->
						{{scope.row[iKey.key].split('-')[0].trim() == '城市合伙人' ? `城市服务商 - ${scope.row[iKey.key].split('-')[1].trim()}` : scope.row[iKey.key]}}
					</span>
					<span v-if="iKey.key=='partnerName' && promotorType==2" >
						<!-- 分销商  获取用户渠道-->
						{{scope.row[iKey.key.split('-')[1].trim()]}}
					</span>
					</el-popover>
		      	</template>
			</el-table-column>
		</el-table>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:currentPage="lockData.curPage"
			:page-sizes="[10, 20, 30, 40]"
			:page-size="lockData.pageSize"
			layout="total, sizes, prev, pager, next"
			:total="lockData.total"
			v-if="lockData">
		</el-pagination>
	</div>
</template>

<script>
	import { authMobile } from '../../api'
	import { parseTime } from '../../utils'
	import { mapGetters } from 'vuex'
	export default {
		data() {
			return {
				lockData: null,
				dateRange: [null,null],
				lockDetailKey: [
					{
						key: 'nickName',
						label: '昵称',
						width: 150,
					},
					{
						key: 'uid',
						label: '用户id',
						width: 120,
					},
					{
						key: 'phoneNum',
						label: '手机号',
						width: 130,
					},
					{
						key: 'origin',
						label: '获取方式',
						width: 180,
					},
					{
						key: 'partnerName',
						label: '获取用户渠道',
						width: 200,
					},
					{
						key: 'displayTime',
						label: '获取时间',
						width: 180,
					}
				]
			}
		},
		computed: {
			...mapGetters([
				'promotorType'
			])
		},
		methods: {
			handleSizeChange(pageSize) {
				let _this = this;
				if(_this.dateRange[0] && _this.dateRange[1]){
					let curPage = _this.lockData.curPage;
					let {from, to} = _this.dateParse();
					_this.fetchData({from, to, curPage, pageSize})
				}else{
					_this.fetchData({pageSize});
				}
			},
			handleCurrentChange(curPage) {
				let _this = this;

				if(_this.dateRange[0] && _this.dateRange[1]){
					let pageSize = _this.lockData.pageSize;
					let {from, to} = _this.dateParse();
					_this.fetchData({from, to, curPage, pageSize})
				}else{
					_this.fetchData({curPage});
				}
			},
			dateParse() {
				let _this = this;
				let from = parseTime(_this.dateRange[0]);
				let to = parseTime(_this.dateRange[1]).replace('00:00:00','23:59:59');
				return {from, to}
			},
			dateFilter() {
				let _this = this;
				if(_this.dateRange[0] && _this.dateRange[1]){
					let {from, to} = _this.dateParse();
					_this.fetchData({from, to})
				}else{
					_this.fetchData({});
				}
			},
			exportParams() {
				let _this = this;
				let from = '', to = '';
				if(_this.dateRange[0] && _this.dateRange[1]){
					return _this.dateParse();
				}
				return {from, to};
			},
			fetchData(obj) {
				let _this = this;
				let params = {};
				if(!obj.from && !obj.to){
					params['curPage'] = (_this.lockData && _this.lockData.curPage) || 1;
					params['pageSize'] = (_this.lockData && _this.lockData.pageSize) || 20;
				}
				for(var key in obj){
					params[key] = obj[key];
				}
				// console.log(params)
				authMobile(params).then(res => {
					if(res.ret === 0){
						let { curPage, pageSize, total } = res.data;
						let maxPage = Math.ceil(total/pageSize);

						if(curPage > maxPage){
							obj['curPage'] = maxPage;
							_this.fetchData(obj)
						}else{
							_this.lockData = res.data;
						}
					}
				})
			},
		},
		created() {
			let _this = this;
			_this.fetchData({});
		}
	}
</script>

<style lang="scss" scoped>
.lockUserDetail{
	width: 960px;
}
.title-con{
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 20px;
	margin-bottom: 10px;
	background-color: #fff;
	.title{
		margin-right: 10px;
		font-size: 18px;
	}
	.lockUserHelp{
		font-size: 14px;
	}
	.dateFilter{
		display: flex;
		align-items: center;
		span{
			margin: 0 10px;
			font-size: 14px;
		}
	}
	.exportText{
	    margin-left: 5px;
	}
}
.tableTips{
	padding: 10px 5px;
	font-size: 14px;
	color: #999;
}
</style>



// WEBPACK FOOTER //
// authUserMobile.vue?f387bb7e